module.exports = __webpack_public_path__ + "static/media/testimonial-2.103c28cc.mp4";